<template>
  <div class="gray-bcg">
    <div><myheader class="relative" /></div>
    <div class="my-10">
      <img
        src="../assets/image/blueShape.png"
        alt="blueShape"
        class="blueShape"
        width="20%"
      />
      <img
        src="../assets/image/greenShape.png"
        alt="greenShape"
        width="30%"
        class="greenShape"
      />
      <div class="container relative">
        <div class="row">
          <div class="col-12 col-lg-6 p-5 my-5">
            <div class="row b1 h1">{{ $t("aboutUs.aboutUs") }}</div>
            <div class="row h5 gray-text">{{ $t("aboutUs.aboutUs2") }}</div>
            <div class="row gray-text justify" align="right">
              {{ $t("aboutUs.aboutUs3") }}
            </div>
          </div>
          <div class="col-12 col-lg-6 p-5 my-5">
            <div class="row b1 h1">{{ $t("aboutUs.service") }}</div>
            <div class="row h5 gray-text">{{ $t("aboutUs.service2") }}</div>
            <div class="row gray-text justify" align="right">
              {{ $t("aboutUs.service3") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <myfooter class="relative" />
  </div>
</template>
<script>
import myheader from "../components/Share/Header.vue";
import myfooter from "../components/Share/Footer.vue";

export default {
  name: "AboutUs",
  components: {
    myheader,
    myfooter,
  },
};
</script>
<style scoped>
.blueShape {
  position: absolute;
  top: 15%;
  right: -10%;
}
.greenShape {
  position: absolute;
  top: 30%;
  right: 90%;
}
</style>
